<template>
  <span class="money_format">{{ formattedValue }}</span>
</template>

<script setup lang="ts">
import { computed } from 'vue'

const props = withDefaults(defineProps<{
  value: number | string
  locale?: string
  currencyCode?: string
  hideSubunits?: boolean
  subunitsValue?: boolean
}>(), {
  locale: 'en-US',
  currencyCode: 'USD',
  hideSubunits: false,
  subunitsValue: false
})

const formattedValue = computed(() => {
  // Convert value to number if it's a string
  const numValue = typeof props.value === 'string' ? parseFloat(props.value) : props.value

  if (isNaN(numValue)) {
    return props.currencyCode === 'USD' ? '$0' : '0'
  }

  const formatter = new Intl.NumberFormat(props.locale, {
    style: 'currency',
    currency: props.currencyCode,
    minimumFractionDigits: props.hideSubunits ? 0 : 2,
    maximumFractionDigits: props.hideSubunits ? 0 : 2,
  })

  return formatter.format(numValue)
})
</script>

<style scoped>
.money_format {
  display: inline;
}
</style>
